import React from 'react';
import QueryStringService from '../../services/queryStringService.js';
import numberFormatter from '../../utils/numberFormatter.js';
import moment from 'moment';

export default class CampaignSummaryPlayOld extends React.Component {
    constructor() {
        super();
        this.queryStringService = new QueryStringService();
        this.state = {
        };
    }


    render() {
        let colorClass;
        let title;
        let target = this.props.selectedData.target;
        let delivered = this.props.selectedData.delivered;
        let asterix = (this.props.selectedDataType !== "plays" && this.props.useAlternateContacts && this.props.spotlength !== 5 && this.props.spotlength !== '') ? '*' : '';
        let country = this.queryStringService.getCurrentCountry();
        let periodEnd = new Date(this.props.selectedDetailsData.endDate);
        let cutoff5secDate = new Date("2023-08-21T00:00:00");
        let playLength = this.props.parameters.defaultSpotLength;
        if (country == 'no' && (periodEnd <= cutoff5secDate || this.props.orderlineInExceptionList)) {
                playLength = '5'
        }

        colorClass = "play-background";

        switch (this.props.selectedDataType) {
            case "plays":
                title = "Plays";
                break;
            case "contacts":
                title = this.props.contactsLabel;
                break;
            default:
                console.log("invalid data type");
        }

        return (
            <div>
                <div className={'campaign-summary ' + colorClass}>
                    <div>
                        <h3>{title}</h3>
                        <table>
                            <tbody>
                            {target > 0 && //target exist if it's > 0
                                <tr>
                                    <th>Goal</th>
                                    <td>{numberFormatter.numberWithSpaces(target)}</td>
                                </tr>
                                }
                                {!this.props.campaignInfo.notStarted &&
                                <tr>
                                    <th>Delivered{asterix}</th>
                                    <td>{numberFormatter.numberWithSpaces(delivered)}</td>
                                </tr>
                                }
                                {delivered > target &&
                                target > 0 && //only show if delivered is larger than target
                                <tr>
                                    <th>Extra value{asterix}</th>
                                    <td>{numberFormatter.numberWithSpaces(delivered - target)}</td>
                                </tr>
                                }
                                {this.props.campaignInfo.notStarted &&
                                <tr>
                                    <th>Not Started</th>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {(this.props.useAlternateContacts && this.props.spotlength !== 5 && this.props.spotlength !== '') &&
                <div>
                * Estimated based on {playLength} sec spot length
                </div>
                }
            </div>
        );
    }
}